/**
 * Dependencies.
 */
import 'vuetify/dist/vuetify.min.css';

import { getTheme, IKitThemes } from '@prz-dp/ui-next';
import Vue from 'vue';
import Vuetify from 'vuetify';

/**
 * Use `Vuetify`.
 */
Vue.use(Vuetify);

/**
 * Export `Vuetify` instance.
 */
export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        ...getTheme(IKitThemes.BASE)
      }
    }
  }
});
